import { CardContent, Grid } from '@mui/material';
import PageLoader from '../../../Components/Spinner/PageLoader';
import { ICompanyDetails } from '../../../rest/types';
import ModalsWrapper from '../../../Components/Modals/ModalsWrapper';
import PdfAndImageView from '../../../Components/pdfAndImageView/PdfAndImageView';
import { useState } from 'react';
import { CommonTypoGraphy } from '../../../Components/pdfAndImageView/CommonTypoGraphy';
import CommonDetailItem, {
  formatDate,
  formatValue,
} from '../../../Components/CommonDetailItem/CommonDetailItem';

type IProps = {
  data: ICompanyDetails;
  loading: boolean;
};

const CardCompanyInformation = ({ data, loading }: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');

  return (
    <>
      {!loading ? (
        <CardContent>
          <Grid container pt={2} spacing={2}>
            <CommonDetailItem
              label='Company name'
              value={formatValue(data?.member_company_name)}
            />
            <CommonDetailItem
              label='Company establish date'
              value={formatDate(data?.member_company_stablished_date, 'Do-MM-YYYY')}
            />
            <CommonDetailItem
              label='Company verified date'
              value={formatDate(data?.member_company_verified_date, 'Do-MM-YYYY')}
            />
            <CommonDetailItem
              label='Company website'
              value={
                data?.member_company_website ? (
                  <a
                    href={`https://${data.member_company_website}`}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {data.member_company_website}
                  </a>
                ) : (
                  'N/A'
                )
              }
            />
            <CommonDetailItem
              label='Company logo'
              value={
                data?.member_company_logo ? (
                  <CommonTypoGraphy
                    name='View company logo'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(data.member_company_logo);
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
            <CommonDetailItem
              label='Mobile Number'
              value={formatValue(data?.phone)}
            />
            <CommonDetailItem
              label='Telephone'
              value={formatValue(data?.cellphone)}
            />
            <CommonDetailItem
              label='Email'
              value={formatValue(data?.email)}
            />
            <CommonDetailItem
              label='Address line 1'
              value={formatValue(data?.addressline1)}
            />
            <CommonDetailItem
              label='Address line 2'
              value={formatValue(data?.addressline2)}
            />
            <CommonDetailItem
              label='Address line 3'
              value={formatValue(data?.addressline3)}
            />
            <CommonDetailItem
              label='Postal code'
              value={formatValue(data?.postalcode)}
            />
            <CommonDetailItem
              label='Zone name'
              value={formatValue(data?.zone_name)}
            />
            <CommonDetailItem
              label='Division name'
              value={formatValue(data?.division_name)}
            />
            <CommonDetailItem
              label='District name'
              value={formatValue(data?.district_name)}
            />
            <CommonDetailItem
              label='Thana name'
              value={formatValue(data?.thana_name)}
            />
            <CommonDetailItem
              label='Area name'
              value={formatValue(data?.area_name)}
            />
          </Grid>
        </CardContent>
      ) : (
        <PageLoader />
      )}
      <>
        <ModalsWrapper
          modalData={{ title: 'View document' }}
          setShowModal={setOpen}
          showModal={open}
        >
          <PdfAndImageView file={imageFile} />
        </ModalsWrapper>
      </>
    </>
  );
};

export default CardCompanyInformation;
